import { auth, googleProvider, facebookProvider } from '../firebase';
import {
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  updateProfile,
  sendEmailVerification,
  UserCredential
} from 'firebase/auth';

export const loginWithEmail = async (email: string, password: string): Promise<UserCredential> => {
  return await signInWithEmailAndPassword(auth, email, password);
};

export const registerWithEmail = async (email: string, password: string, name: string): Promise<UserCredential> => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    if (userCredential.user) {
      await updateProfile(userCredential.user, { displayName: name });
      await sendEmailVerification(userCredential.user, {
        url: `${window.location.origin}/verify-email`,
        handleCodeInApp: true
      });
    }
    return userCredential;
  } catch (error: any) {
    // 可根據 error.code 回傳更友善訊息
    throw error;
  }
};

export const loginWithGoogle = async (): Promise<UserCredential> => {
  try {
    console.log('開始 Google 登入流程...');
    // 直接使用 popup 登入
    return await signInWithPopup(auth, googleProvider);
  } catch (error) {
    console.error('Google 登入失敗:', error);
    throw error;
  }
};

export const loginWithFacebook = async (): Promise<UserCredential> => {
  try {
    console.log('開始 Facebook 登入流程...');
    // 直接使用 popup 登入
    return await signInWithPopup(auth, facebookProvider);
  } catch (error) {
    console.error('Facebook 登入失敗:', error);
    throw error;
  }
};

export const logout = async () => {
  return await signOut(auth);
};

export const updateUserProfile = async (displayName: string, photoURL?: string) => {
  if (auth.currentUser) {
    await updateProfile(auth.currentUser, { displayName, photoURL });
  }
}; 